export var DASHBOARD_PATH;
(function (DASHBOARD_PATH) {
    DASHBOARD_PATH["DASHBOARD"] = "/dashboard";
    DASHBOARD_PATH["CHANGE_PASSWORD_PAGE"] = "/changepwd";
    DASHBOARD_PATH["MY_KPOS_STATUS"] = "/mykposstatus";
    DASHBOARD_PATH["KPOS_MONITOR"] = "/kposmonitor";
})(DASHBOARD_PATH || (DASHBOARD_PATH = {}));
